import LOCALE from '@app/configs/locale';
const defineLocale = () => {
    const locale = window.location.pathname.match(/[a-zA-Z]{2}/);
    if (locale && LOCALE.LOCALES.includes(locale[0])) {
        return locale[0];
    }
    const storedLocale = localStorage.getItem('locale');
    if (storedLocale && LOCALE.LOCALES.includes(storedLocale)) {
        return storedLocale;
    }
    return LOCALE.DEFAULT_LOCALE;
};
export default defineLocale;
